import {ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Device} from '../../models/device.model';
import {
  catchError,
  finalize,
  forkJoin,
  from,
  interval,
  Observable,
  Subject,
  Subscription,
  takeUntil,
  tap,
  throwError,
  zip
} from 'rxjs';
import {DeviceService} from '../../service/devices.service';
import {EventService} from '../../service/event.service';
import {MapsService} from '../../service/maps.service';
import {RealTimeService} from '../../service/real-time.service';
import {AppEvents} from '../../shared/enums/app-events.enum';
import {Cluster, MarkerClusterer, Renderer, SuperClusterAlgorithm} from "@googlemaps/markerclusterer";
import {StorageKeys} from '../../shared/enums/storage-keys.enum';
import {MessageService} from 'primeng/api';
import {BreadcrumbService} from "../../service/breadcrumb.service";
import {AlertService} from 'src/app/service/alert.service';
import {WebSocketService} from 'src/app/service/websocket.service';
import {ThemeService} from "../../service/theme.service";
import {GA4Service} from "../../service/ga4.service";
import {DARK_MAP_STYLE, LIGHT_MAP_STYLE} from "../../shared/constants/map-styles.const";

@Component({
  selector: 'app-real-time',
  templateUrl: './real-time.component.html',
  styleUrls: ['./real-time.component.scss']
})
export class RealTimeComponent implements OnInit, OnDestroy {
  private _destroy$: Subject<void> = new Subject<void>();
  showInfoWindow = false;
  infoWindowData: any[] = [];
  isOpenLayers = false;// True = openlayer, false = google maps, alterar types/geojson para o "devDependencies"
  devices!: Array<Device>;
  devicesFilter: Device[] = [];
  devicesMarker: any[] = []
  webMap!: google.maps.Map;
  isDarkMap: boolean = localStorage.getItem(StorageKeys.MAP_DARK_MODE) === 'true';
  heatmap!: google.maps.visualization.HeatmapLayer;
  truckHeatMap!: google.maps.visualization.HeatmapLayer;
  cluster!: MarkerClusterer;
  markers: Array<google.maps.Marker> = [];
  idInterval: any;

  retentionPoints: any;
  loadingRetentionPoints!: boolean;
  retentionPointsPage: number = 0;
  loading = false;
  loadingMap = true;
  loadingStatus = false;

  private trafficLayer!: google.maps.TrafficLayer;
  private trafficLayerSubscription!: Subscription;
  private bounds: any;

  devicesPoints: any[] = [];

  onlyWim = false;
  refreshMarkersIntervalId = 0;
  pendingFilteredDevices: any[] | null = null;

  dataMetrics: any;

  @ViewChild('card', {read: ElementRef}) public card!: ElementRef<any>;

  constructor(private deviceService: DeviceService,
              private cd: ChangeDetectorRef,
              private eventService: EventService,
              private mapsService: MapsService,
              private realTimeService: RealTimeService,
              private alertService: AlertService,
              public themeService: ThemeService,
              private messageService: MessageService,
              private wsService: WebSocketService,
              private breadCrumb: BreadcrumbService,
              private ga4Service: GA4Service) {
  }

  ngOnInit() {
    this.breadCrumb.next([
      {label: 'Monitoramento', icon: 'pi pi-fw pi-desktop'},
      {label: 'Tempo Real', icon: 'pi pi-fw pi-clock'}
    ]);

    // Rastreamento de usuário ativo por tela
    this.ga4Service.trackActiveUserByScreen('Pulse VS - Mapa', 'Pulse VS - Mapa');

    this.getDevices().pipe(
      tap(async () => {
        await this.changeLayerTaxa(false); // generate map layers
      })
    ).subscribe()
    this.getRetentionPoints();
    this.trafficLayerSubscription = this.eventService.subscribe(AppEvents.UPDATE_MAPS_TRAFFIC_LAYER, (trafficLayerEnabled: boolean) => {
      if (this.webMap) {
        this.updateTrafficLayer(trafficLayerEnabled);
      }
    });
    this.refreshMarkers();
    //teste de envio do alerta
    // setInterval(() => {
    //   this.messageService.add({
    //     key: 'toastAlert',
    //     severity: 'info',
    //     summary: 'Alerta!',
    //     detail: 'Equipamento P208 - Câmera sem funcionamento'
    //   });
    // }, 3000);
    //fluxo para teste de websocket
  }

  websocketConnect(){
    const groupIds: number[] = [];

    this.devices.forEach(device => {
      if (!groupIds.includes(device.groupId)) {
        groupIds.push(device.groupId);
      }
    });
    this.wsService.connect(groupIds);
    this.wsService.getMessages()
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (msg) => {
          if (msg) {
            console.log('Mensagem recebida:', msg);
          }
        },
        error: (err) => console.error('Erro WebSocket:', err),
      });
  }

  websocketSendMessage() {
    this.wsService.sendMessage('user', { type: 'WORK', text: 'Minha mensagem' });
  }

  verifyDeviceNavigate() {
    this.alertService.getDeviceToNavigate().pipe(
      takeUntil(this._destroy$),
      tap((r) => {
        if (r != null) {
          const item: any = this.devices.find((e: any) => e.deviceId === r);
          if (item !== undefined) {
            this.toLocation({lat: Number(item.latitude), lng: Number(item.longitude)});
          }
          this.alertService.setDeviceToNavigate(null);
        }
      })
    ).subscribe()

  }

  toLocation(location: any) {
    this.webMap.setCenter(location);
    this.webMap.setZoom(20);
  }

  updateData($event: any) {
    this.dataMetrics = $event;
  }

  ngOnDestroy(): void {
    //this.wsService.disconnect();
    this._destroy$.next();
    this._destroy$.complete();

    if (this.trafficLayerSubscription) {
      this.trafficLayerSubscription.unsubscribe();
      this.eventService.destroy(AppEvents.UPDATE_MAPS_TRAFFIC_LAYER);
    }
    if (this.idInterval) {
      clearInterval(this.idInterval);
    }
  }

  setInfoWindowData(event: any) {
    this.infoWindowData = [];
    this.infoWindowData.push(event);
  }

  // MAPA
  // ---------------------

  getStatusAllDevices() {
    if (this.devices.length > 0) {
      this.loadingStatus = true;
      const statuses: Observable<any>[] = [];
      this.devices.forEach(device => statuses.push(this.getStatus(device)))
      forkJoin(statuses)
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: () => {
            this.loadingStatus = false;
            this.cluster.clearMarkers();
            this.setMarkersByDevices(this.devices);
            this.cluster.addMarkers(this.markers);

            this.dataMetrics = this.devices;
          }
        });
    }
  }

  getDevices(): Observable<any> {
    this.loadingMap = true;
    return this.deviceService.getDeviceMetrics().pipe(
      takeUntil(this._destroy$),
      finalize(() => {
        this.loadingMap = false;
        this.getStatusAllDevices();
        //this.websocketConnect();
      }),
      catchError((err: any) => {
        this.errorAlert(err.message)
        return throwError(err)
      }),
      tap((response) => {
        if (response) {
          this.devices = response;
          this.dataMetrics = this.devices;
        }
      })
    )
  }

  getStatus(device: any): Observable<any> {
    return this.deviceService.getDeviceStatus(device)
      .pipe(takeUntil(this._destroy$),
        tap((status: any) => {
          device.statusOnline = status.statusOnline
        }));
  }

  private loadWebMap(): void {
    from(this.mapsService.loadGoogleMapsJsApi())
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (mapLoaded) => {
          if (!mapLoaded) {
            this.messageService.add({
              key: 'toastError',
              severity: 'error',
              summary: 'Error',
              detail: 'Não foi possível carregar o mapa'
            });
            return;
          }
          this.setMarkers(this.onlyWim);//preserva o filtro wim
          this.mapConfig();
          this.loadHeatMap();
          this.loadTruckHeatMap();
        },
        error: () => {
          this.messageService.add({
            key: 'toastError',
            severity: 'error',
            summary: 'Error',
            detail: 'Não foi possível carregar o mapa'
          });
        }
      })
  }

  loadHeatMap() {
    let pointsCompare: any[] = [];
    for (let i = 0; i < this.devicesFilter.length; i++) {
      const devices: any = this.devicesFilter.filter(res => res.latitude === this.devicesFilter[i].latitude);
      if (devices.length === 1) {
        this.devicesPoints.push({
          location: new google.maps.LatLng(Number(devices[0].latitude), Number(devices[0].longitude)),
          weight: Number(devices[0].taxaOcupacao)
        });
      } else {
        if (!pointsCompare.find(res => res.latitude === devices[0].latitude)) {
          pointsCompare.push(devices[0]);
          this.devicesPoints.push({
            location: new google.maps.LatLng(Number(devices[0].latitude), Number(devices[0].longitude)),
            weight: Number(devices[0].taxaOcupacao)
          });
        }
      }
    }
    this.heatmap = new google.maps.visualization.HeatmapLayer({
      data: this.devicesPoints,
      maxIntensity: 10,
    });
    this.heatmap.setMap(null);
    this.heatmap.set("radius", this.heatmap.get("radius") ? null : 30);
  }

  loadTruckHeatMap() {
    this.deviceService.getOccupancyTruck()
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (truckOccupancy) => {
          const truckMap: any[] = [];
          for (let i = 0; i < truckOccupancy.length; i++) {
            truckMap.push({
              location: new google.maps.LatLng(Number(truckOccupancy[i].latitude), Number(truckOccupancy[i].longitude)),
              weight: Number(truckOccupancy[i].taxaDeCaminhao)
            });
          }
          this.truckHeatMap = new google.maps.visualization.HeatmapLayer({
            data: truckMap,
            maxIntensity: 10
          });
          this.truckHeatMap.setMap(null);
          this.truckHeatMap.set("radius", this.heatmap.get("radius") ? null : 30);
        }
      });
  }

  setMarkers(onlyWim = false) {
    this.markers.splice(0, this.markers.length);
    this.bounds = new google.maps.LatLngBounds();
    let _devices = this.devices;
    if (onlyWim)
      _devices = this.devices.filter(d => d.category === 'WIM');
    _devices.forEach((d: any) => {
      if (d.latitude && d.longitude
        && Number(d.latitude) < 10 && Number(d.latitude) > -53
        && Number(d.longitude) < -29 && Number(d.longitude) > -80) {
        this.devicesFilter.push(d);
        const marker = this.createMarker(d);
        this.markers.push(marker);
        this.bounds.extend(marker.getPosition());
      }
    });
    //this.drawRoute(this.devices[0].latitude,this.devices[0].longitude,this.devices[5].latitude,this.devices[5].longitude)
  }

  private readonly PIN_PALETTE: { [status: number]: { light: string; base: string; dark: string; tint: string; num: string } } = {
    0: { light: '#fb7185', base: '#e23b3b', dark: '#a81f1f', tint: '#ffeceb', num: '#a81c1c' }, // vermelho (offline)
    1: { light: '#fcd34d', base: '#f2ab12', dark: '#b45309', tint: '#fff5df', num: '#93500a' }, // amarelo (sem passagem)
    2: { light: '#4ade80', base: '#16a34a', dark: '#0f7a37', tint: '#e9fdf1', num: '#0f6b34' }, // verde (online)
    9: { light: '#cbd5e1', base: '#94a3b8', dark: '#475569', tint: '#eef2f7', num: '#3f4a5a' }, // cinza (demais)
  };
  private readonly pinIconCache: { [cacheKey: string]: google.maps.Icon } = {};

  private pinStatusKey(statusOnline: number): number {
    return [0, 1, 2].includes(statusOnline) ? statusOnline : 9;
  }

  /** Cor do número do pin (tom do status, legível sobre o centro claro). */
  private getPinLabelColor(statusOnline: number): string {
    return this.PIN_PALETTE[this.pinStatusKey(statusOnline)].num;
  }

  private buildPinSvgIcon(statusOnline: number, dark = false): google.maps.Icon {
    const key = this.pinStatusKey(statusOnline);
    const cacheKey = `${key}:${dark ? 'd' : 'l'}`;
    if (this.pinIconCache[cacheKey]) return this.pinIconCache[cacheKey];

    const c = this.PIN_PALETTE[key];
    const halo = dark
      ? { r: 34, inner: 0.75, mid: 0.32, color: c.light }   // dark: acende o mapa
      : { r: 27, inner: 0.32, mid: 0.11, color: c.base };    // light: apenas um respiro
    const P = 12;                 // padding do canvas p/ o halo caber
    const W = 54, H = 66;         // dimensões do pin (mantidas)
    const VW = W + 2 * P, VH = H + 2 * P;
    const body =
      `M27 2 C14.85 2 5 11.85 5 24 C5 36.5 22.6 58 25.6 61.4 C26.3 62.2 27.7 62.2 28.4 61.4 C31.4 58 49 36.5 49 24 C49 11.85 39.15 2 27 2 Z`;
    const svg =
      `<svg xmlns="http://www.w3.org/2000/svg" width="${VW}" height="${VH}" viewBox="${-P} ${-P} ${VW} ${VH}">` +
        `<defs>` +
          `<linearGradient id="body" x1="0" y1="0" x2="0" y2="1">` +
            `<stop offset="0%" stop-color="${c.light}"/>` +
            `<stop offset="55%" stop-color="${c.base}"/>` +
            `<stop offset="100%" stop-color="${c.dark}"/>` +
          `</linearGradient>` +
          `<radialGradient id="inner" cx="50%" cy="40%" r="62%">` +
            `<stop offset="0%" stop-color="#ffffff"/>` +
            `<stop offset="100%" stop-color="${c.tint}"/>` +
          `</radialGradient>` +
          `<radialGradient id="halo" cx="50%" cy="50%" r="50%">` +
            `<stop offset="0%" stop-color="${halo.color}" stop-opacity="${halo.inner}"/>` +
            `<stop offset="45%" stop-color="${halo.color}" stop-opacity="${halo.mid}"/>` +
            `<stop offset="100%" stop-color="${halo.color}" stop-opacity="0"/>` +
          `</radialGradient>` +
          `<filter id="sh" x="-70%" y="-50%" width="240%" height="220%"><feGaussianBlur stdDeviation="1.6"/></filter>` +
        `</defs>` +
        `<circle cx="27" cy="24" r="${halo.r}" fill="url(#halo)"/>` +
        `<ellipse cx="27" cy="62.5" rx="6.5" ry="2.2" fill="#000000" opacity="${dark ? 0.42 : 0.24}" filter="url(#sh)"/>` +
        `<path d="${body}" fill="url(#body)" fill-opacity="0.97"/>` +
        `<path d="${body}" fill="none" stroke="${dark ? '#05070a' : '#0e1116'}" stroke-opacity="${dark ? 0.55 : 0.5}" stroke-width="1.6"/>` +
        `<path d="M12 17 A21 21 0 0 1 41 9.5" fill="none" stroke="#ffffff" stroke-opacity="${dark ? 0.5 : 0.45}" stroke-width="2.1" stroke-linecap="round"/>` +
        `<circle cx="27" cy="24" r="16.5" fill="url(#inner)"/>` +
        `<circle cx="27" cy="24" r="16.5" fill="none" stroke="${c.dark}" stroke-opacity="0.22" stroke-width="1"/>` +
      `</svg>`;

    const icon: google.maps.Icon = {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(VW, VH),
      anchor: new google.maps.Point(27 + P, 62 + P),
      labelOrigin: new google.maps.Point(27 + P, 24 + P),
    };
    this.pinIconCache[cacheKey] = icon;
    return icon;
  }

  createMarker(d: any) {
    // 0 - off
    // 1 - amarelo - sem passagem
    // 2 - on
    // 3 - suspenso
    // outro - cinza escuro
    const equipamentName =  d.groupId == 24 ? d.deviceName.slice(-2) :
                             d.groupId == 34 ? this.getEquipmentName(d.deviceName, 34) :
                             d.groupId == 619 ? this.getEquipmentName(d.deviceName, 619) :
                             d.groupId == 622 ? this.getEquipmentName(d.deviceName, 622) :
                             d.groupId == 623 ? d.deviceName.slice(-2) :
                             d.groupId == 624 ? d.deviceName.slice(-3) :
                             '1';
    const labelConfig = {
      text:  equipamentName || '1',
      fontWeight: 'bold',
      color: this.getPinLabelColor(d.statusOnline),
      className: 'cluster-number-pin'
    };
    const marker: google.maps.Marker = new google.maps.Marker({
      // @ts-ignore
      data: d,
      position: {
        lat: Number(d.latitude),
        lng: Number(d.longitude)
      },
      // optimized: false,
      // icon: "/assets/images/pin_radar.png"
      icon: this.buildPinSvgIcon(d.statusOnline, this.isDarkMap),
        label: labelConfig || undefined
    });
    (marker as any).device = d;
    marker.addListener("click", () => {
      this.infoWindowData = [];
      this.loading = true;
      this.deviceService.getDeviceMetricsbyId(d.equipmentId)
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: (metricsById) => {
            this.devicesMarker = [d];
            this.infoWindowData.push(metricsById);
            this.loading = false;
            this.showInfoWindow = true;
          },
          error: (err) => this.messageService.add({key: 'toastError', severity: 'error', summary: 'Error', detail: err})
        })
    });
    return marker;
  }

  mapConfig() {
    const mapEle: any = document.getElementById("map") as HTMLElement;
    this.webMap = new google.maps.Map(mapEle, {
      center: {
        lat: -25.4321587,
        lng: -49.2796673
      },
      zoom: 15,
      gestureHandling: 'greedy',
      zoomControl: true,
      maxZoom: 50,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      styles: this.currentMapStyle
    });
    this.loadTrafficLayer();
    google.maps.event.addListenerOnce(this.webMap, 'tilesloaded', () => {
      // A função dentro deste bloco será executada após o mapa ser totalmente renderizado
      this.verifyDeviceNavigate();
    });


  }

  loadTrafficLayer() {
    this.trafficLayer = new google.maps.TrafficLayer();
    this.trafficLayer.setMap(null);

    setTimeout(() => {
      this.webMap.fitBounds(this.bounds);
      this.addCluster();
      const trafficLayerEnabled: boolean = localStorage.getItem(StorageKeys.TRAFFIC_LAYER_ENABLED) != null;
      this.updateTrafficLayer(trafficLayerEnabled);
    });
  }

  changeLayerTraffic(event: any) {
    if (event) {
      this.trafficLayer.setMap(this.trafficLayer.getMap() ? null : this.webMap);
    } else {
      this.trafficLayer?.setMap(null);
    }
  }

  changeLayerHeat(event: any) {
    if (event) {
      this.changeLayerCaminhao(false);
      this.heatmap.setMap(this.heatmap.getMap() ? null : this.webMap);
    } else {
      this.heatmap?.setMap(null);
    }
  }

  changeLayerCaminhao(event: any) {
    if (event) {
      this.changeLayerHeat(false);
      this.truckHeatMap.setMap(this.truckHeatMap.getMap() ? null : this.webMap);
    } else {
      this.truckHeatMap?.setMap(null);
    }
  }

  changeLayerTaxa(event: any) {
    this.markers = [];
    this.isOpenLayers = event;
    if (!this.isOpenLayers) {
      const googleMapsRemove = document.getElementById('map');
      googleMapsRemove?.remove();
      const googleMapsDiv = document.createElement('div');
      const mainDiv = document.getElementById('mainDiv');
      googleMapsDiv.setAttribute('id', 'map');
      googleMapsDiv.setAttribute('class', 'map-content');
      // googleMapsDiv.style.width = '100vw';
      googleMapsDiv.style.height = this.themeService.showHeader ? '89vh' : `100vh`;
      mainDiv?.appendChild(googleMapsDiv);
      this.loadWebMap();
    } else {
      const googleMapsRemove = document.getElementById('map');
      googleMapsRemove?.remove();
    }
  }

  getDominantStatus(markers: any): number {
    // 0 - off
    // 1 - amarelo - sem passagem
    // 2 - on
    // 3 - suspenso
    // outro - cinza escuro
    let dominantStatus = 2;
    const offlineMarkers = markers.filter((m: any) => m.device.statusOnline === 0);
    const delayedMarkers = markers.filter((m: any) => m.device.statusOnline === 1);
    const otherMarkers = markers.filter((m: any) =>
      m.device.statusOnline != 0
      && m.device.statusOnline != 1
      && m.device.statusOnline != 2
    );

    if (otherMarkers.length > 0)
      dominantStatus = 9;
    if (delayedMarkers.length > 0)
      dominantStatus = 1;
    if (offlineMarkers.length > 0)
      dominantStatus = 0;

    return dominantStatus;
  }

  onClusterClick(markers: any) {
    if (Number(this.webMap.getZoom()) >= 16) {
      this.loading = true;
      this.devicesMarker = markers?.map((res: any) => res.device);
      const httpRequests = [];

      this.infoWindowData = [];
      let devicesName: any = []
      for (const d of this.devicesMarker) {
        if (!devicesName.some((item: any) => item === d.deviceName)) {
          httpRequests.push(this.deviceService.getDeviceMetricsbyId(d.equipmentId));
          devicesName.push(d.deviceName);
        }
      }
      zip(httpRequests)
        .pipe(
          takeUntil(this._destroy$),
          finalize(() => this.loading = false),
        )
        .subscribe({
          next: (metricsByIdList) => {
            metricsByIdList.forEach(metricsById => this.infoWindowData.push(metricsById));
            this.showInfoWindow = true;
          },
          error: (err) => this.messageService.add({
            key: 'toastError',
            severity: 'error',
            summary: 'Error',
            detail: err
          }),
        });
    } else {
    }
  }

  getEquipmentName(value: string, contractId: number): string {
    if(contractId == 34){
      const index = value.indexOf("P0");
      if (index !== -1 && value.length >= index + 5) {
        return value.substring(index + 2, index + 5);
      }
    }else if(contractId==619){
      const index = value.indexOf("VAC 0");
      if (index !== -1 && value.length >= index + 7) {
        return value.substring(index + 5, index + 7);
      }else{
        const index = value.indexOf("VAC0");
        if (index !== -1 && value.length >= index + 6) {
          return value.substring(index + 4, index + 6);
        }
      }
    }else if(contractId==622){
        const index = value.indexOf("NV38100");
      if (index !== -1 && value.length >= index + 9) {
         return value.substring(index + 7, index + 9);
      }
    }
    return "";
  }

  private addCluster(): void {
    const renderer: Renderer = {
      render: ({count, position, markers}: Cluster) => {
        let primaryMarker: any = []
        if (markers && markers.length > 0) {
          const sortedMarkers: any = markers.sort((a: any, b: any) => a.device.statusOnline - b.device.statusOnline);
          primaryMarker = sortedMarkers[0].data;
        }
        const dominantStatus = this.getDominantStatus(markers);
        const marker = new google.maps.Marker({
          position,
          icon: this.buildPinSvgIcon(dominantStatus, this.isDarkMap),
          label: {
            text:primaryMarker.groupId === 24
            ? primaryMarker.deviceName.slice(-2)
            : primaryMarker.groupId === 34
            ? this.getEquipmentName(primaryMarker.deviceName, 34)
            : primaryMarker.groupId === 619
            ? this.getEquipmentName(primaryMarker.deviceName, 619)
            : primaryMarker.groupId === 622
            ? this.getEquipmentName(primaryMarker.deviceName, 622)
            : primaryMarker.groupId === 623
            ? primaryMarker.deviceName.slice(-2)
            : primaryMarker.groupId === 624
            ? primaryMarker.deviceName.slice(-3)
            : String(count),
            fontWeight: 'bold',
            color: this.getPinLabelColor(dominantStatus),
            className: 'cluster-number-pin'
          }
        });
        marker.addListener("click", () => {
          this.onClusterClick(markers);
        });
        return marker;
      }

    };

    this.cluster = new MarkerClusterer({
      map: this.webMap,
      markers: this.markers,
      renderer,
      algorithm: new SuperClusterAlgorithm({
        radius: 8,
      }),

    });

    if (this.pendingFilteredDevices) {
      const pendingFilteredDevices = this.pendingFilteredDevices;
      this.pendingFilteredDevices = null;
      this.filterMarkersByDevices(pendingFilteredDevices);
    }
  }

  // drawRoute(lat1: any, lng1: any, lat2: any, lng2: any) {
  //   console.log(lat1,lng1,lat2,lng2)
  //   const directionsService = new google.maps.DirectionsService();
  //   const directionsRenderer = new google.maps.DirectionsRenderer({
  //     suppressMarkers: true, // Não exibe os ícones padrão do Google
  //     polylineOptions: {
  //      // strokeColor: color, // Define a cor da rota
  //       strokeOpacity: 0.7,
  //       strokeWeight: 4
  //     }
  //   });

  //   console.log(directionsRenderer)
  //   directionsRenderer.setMap(this.webMap);

  //   const request = {
  //     origin: { lat: Number(lat1), lng: Number(lng1) },
  //     destination: { lat: Number(lat2), lng: Number(lng2) },
  //     travelMode: google.maps.TravelMode.DRIVING // Pode ser WALKING, BICYCLING, TRANSIT
  //   };

  //   directionsService.route(request, (result, status) => {
  //     if (status === google.maps.DirectionsStatus.OK) {
  //       directionsRenderer.setDirections(result);
  //     } else {
  //       console.error("Erro ao traçar rota:", status);
  //     }
  //   });
  // }

  private updateTrafficLayer(trafficLayerEnabled: boolean): void {
    if (!this.trafficLayer) {
      this.trafficLayer = new google.maps.TrafficLayer();
    }
    if (trafficLayerEnabled) {
      this.trafficLayer.setMap(this.webMap);
    } else {
      this.trafficLayer.setMap(null);
    }
  }

  get currentMapStyle(): google.maps.MapTypeStyle[] {
    return this.isDarkMap ? DARK_MAP_STYLE : LIGHT_MAP_STYLE;
  }

  toggleMapTheme(): void {
    this.isDarkMap = !this.isDarkMap;
    localStorage.setItem(StorageKeys.MAP_DARK_MODE, String(this.isDarkMap));
    this.webMap?.setOptions({styles: this.currentMapStyle});
    this.refreshMarkerIcons();
  }

  /** Reconstrói os markers p/ que o halo dos pins acompanhe o tema (claro/escuro). */
  private refreshMarkerIcons(): void {
    if (!this.cluster) return;
    const current = [...this.devicesFilter];
    this.cluster.clearMarkers();
    this.setMarkersByDevices(current);
    this.cluster.addMarkers(this.markers);
  }

  // Gráficos e tabelas
  // ---------------------

  getRetentionPoints(): void {
    this.retentionPointsPage++;
    this.loadingRetentionPoints = true;
    this.realTimeService.obterPontosRetencao()
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => this.loadingRetentionPoints = false),
      )
      .subscribe({
        next: (retentionPoints) => this.retentionPoints = retentionPoints,
        error: (error) => {
          this.retentionPointsPage--;
          this.errorAlert(error.message);
        },
      });
  }

  errorAlert(error: any) {
    this.messageService.add({key: 'toastError', severity: 'error', summary: 'Error', detail: error});
  }

  filterOnlyWim(event: any) {//refact: staticly set wim markers
    this.onlyWim = event;
    this.cluster.clearMarkers();
    if (event) {
      this.setMarkers(true);
    } else {
      this.setMarkers(false);
    }
    this.cluster.addMarkers(this.markers);
  }

  filterMarkersByDevices(devices: any[]) {
    if (!this.cluster || !this.webMap) {
      this.pendingFilteredDevices = devices ?? [];
      return;
    }

    this.cluster.clearMarkers();
    this.setMarkersByDevices(this.onlyWim
      ? (devices ?? []).filter(device => device.category === 'WIM')
      : devices ?? []
    );
    this.cluster.addMarkers(this.markers);
  }

  setMarkersByDevices(_devices: any) {
    this.markers = [];
    this.devicesFilter = [];
    this.bounds = new google.maps.LatLngBounds();
    _devices.forEach((d: any) => {
      if (d.latitude && d.longitude
        && Number(d.latitude) < 10 && Number(d.latitude) > -53
        && Number(d.longitude) < -29 && Number(d.longitude) > -80) {
        this.devicesFilter.push(d);
        const marker = this.createMarker(d);
        this.markers.push(marker);
        this.bounds.extend(marker.getPosition());
      }
    });
  }

  private refreshMarkers() {
    interval(600000) // 600000
      .pipe(
        takeUntil(this._destroy$),
        tap(() => {
          this.getDevices().pipe(
            tap((res) => {
              if (res.length == 0) return;
              this.cluster.clearMarkers();
              this.setMarkersByDevices(res);
              this.cluster.addMarkers(this.markers);
            })
          ).subscribe()
        }),
      )
      .subscribe();
  }

}
